/**
 * 手機版判定
 *
 * 手機版不是把桌面版縮小，而是一套完全不同的殼：沒有側欄、沒有頁面，只剩對話。
 * 所以整個 app 只需要一個布林值來決定走哪一棵樹，斷點取 Tailwind 的 `md`（768px）。
 *
 * 值放在 `useState` 而不是直接讀 `matchMedia`，是為了 SSR：
 * 伺服器端拿不到視窗寬度，先用 request header 猜一個初值（見 plugins/02.viewport.ts），
 * 同一份值序列化進 payload，hydration 時兩邊的 vnode 樹才會一致；
 * mounted 之後再用真實的視窗寬度校正，之後跟著 media query 走。
 */

export const MOBILE_MAX_WIDTH = 767;
export const MOBILE_MEDIA_QUERY = `(max-width: ${MOBILE_MAX_WIDTH}px)`;

/**
 * 只認手機，不認平板：Android 平板與桌面模式的 iPad UA 都沒有 `Mobi`，
 * 它們的寬度本來就落在桌面版範圍，猜成桌面版反而不會閃一下。
 */
const MOBILE_UA_PATTERN = /Mobi|Android|iPhone|iPod|Windows Phone/i;

/**
 * 從 request header 猜這是不是手機。
 * `sec-ch-ua-mobile` 是 Chromium 系瀏覽器主動送的 client hint，有就以它為準；
 * 沒有（Safari / Firefox）才退回看 User-Agent。
 */
export const guessIsMobileFromHeaders = (headers: Record<string, string | undefined>): boolean => {
  const clientHint = headers['sec-ch-ua-mobile'];
  if (clientHint) return clientHint === '?1';
  return MOBILE_UA_PATTERN.test(headers['user-agent'] ?? '');
};

/** 目前是否為手機版視窗（< md） */
export const useIsMobile = () => useState<boolean>('isMobileViewport', () => false);
